// Mock data for Center Portal

export const currentCenter = {
  id: "CTR-001",
  name: "Delhi Assessment Center",
  address: "Plot 45, Sector 18, Dwarka, New Delhi - 110078",
  city: "New Delhi",
  email: "delhi@sba-center.org",
  phone: "+91-11-4567-8901",
  contactPerson: "Mr. Rajesh Gupta",
  status: "active",
  rating: "green",
  accreditedDate: "2023-06-15",
  logo: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=100&h=100&fit=crop"
};

export const centerStats = {
  totalEducatorsAssessed: 1250,
  thisMonthAssessed: 48,
  passRate: 78.5,
  avgScore: 72.3,
  activeMAs: 8,
  revenueThisMonth: 230400,
  revenueThisYear: 2880000,
  pendingPayout: 115200,
  qualityScore: 92
};

export const masterAssessors = [
  { id: "MA-001", name: "Dr. Sunita Verma", photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&crop=face", status: "active", credibilityScore: 94, educatorsAssessed: 320, specializations: ["Mathematics", "Science"] },
  { id: "MA-002", name: "Mr. Anil Kumar", photo: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face", status: "active", credibilityScore: 89, educatorsAssessed: 280, specializations: ["English", "Social Studies"] },
  { id: "MA-003", name: "Mrs. Priya Singh", photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face", status: "active", credibilityScore: 91, educatorsAssessed: 245, specializations: ["Physics", "Chemistry"] },
  { id: "MA-004", name: "Dr. Rakesh Sharma", photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face", status: "recertification_pending", credibilityScore: 86, educatorsAssessed: 195, specializations: ["Biology"] }
];

export const registeredEducators = [
  { id: "EDU-C001", name: "Ms. Anjali Mehta", email: "anjali@school.com", phone: "+91-99887-76655", institute: "Delhi Public School", domain: "Mathematics", level: "Secondary", status: "certified", certificationLevel: "A", score: 88 },
  { id: "EDU-C002", name: "Mr. Vikram Patel", email: "vikram@school.com", phone: "+91-99887-76656", institute: "Ryan International", domain: "Science", level: "Middle School", status: "part2_scheduled", scheduledDate: "2025-01-20", part1Score: 75 },
  { id: "EDU-C003", name: "Mrs. Kavita Sharma", email: "kavita@school.com", phone: "+91-99887-76657", institute: "Kendriya Vidyalaya", domain: "English", level: "Primary", status: "part1_pending" },
  { id: "EDU-C004", name: "Dr. Suresh Reddy", email: "suresh@school.com", phone: "+91-99887-76658", institute: "DAV Public School", domain: "Physics", level: "Senior Secondary", status: "certified", certificationLevel: "B", score: 76 },
  { id: "EDU-C005", name: "Ms. Neha Gupta", email: "neha@school.com", phone: "+91-99887-76659", institute: "Modern School", domain: "Chemistry", level: "Senior Secondary", status: "results_awaited" }
];

export const assessmentSlots = [
  { id: "SLOT-001", date: "2025-01-20", time: "10:00 AM", maxCapacity: 10, bookedCount: 7, assignedMA: "MA-001", status: "open" },
  { id: "SLOT-002", date: "2025-01-20", time: "2:00 PM", maxCapacity: 10, bookedCount: 10, assignedMA: "MA-002", status: "full" },
  { id: "SLOT-003", date: "2025-01-22", time: "10:00 AM", maxCapacity: 10, bookedCount: 4, assignedMA: "MA-003", status: "open" }
];

export const payoutHistory = [
  { id: "PAY-C001", period: "December 2024", assessmentsCount: 52, grossAmount: 249600, netAmount: 187200, status: "paid", paidDate: "2025-01-05" },
  { id: "PAY-C002", period: "November 2024", assessmentsCount: 45, grossAmount: 216000, netAmount: 162000, status: "paid", paidDate: "2024-12-05" },
  { id: "PAY-C003", period: "January 2025", assessmentsCount: 48, grossAmount: 230400, netAmount: 172800, status: "pending", expectedDate: "2025-02-05" }
];

export const complianceChecklist = [
  { id: 1, item: "Proctoring standards documentation", status: "completed", lastUpdated: "2024-12-01" },
  { id: 2, item: "Assessment room photos uploaded", status: "completed", lastUpdated: "2024-11-15" },
  { id: 3, item: "MA training certificates", status: "completed", lastUpdated: "2024-10-20" },
  { id: 4, item: "Fire safety compliance", status: "pending", dueDate: "2025-01-31" },
  { id: 5, item: "Accessibility audit", status: "completed", lastUpdated: "2024-09-10" }
];

export const qualityAssuredTracker = {
  totalStaff: 85,
  certifiedStaff: 68,
  inProgressStaff: 12,
  notStartedStaff: 5,
  percentageCertified: 80,
  targetPercentage: 80,
  isQualityAssured: true
};
